export default [
  {
    path: '/tourism',
    component: () => import('@/views/Tourism.vue'),
    name: 'tourism',
    meta: {
      navName: 'tourism',
      sideNav: true,
      requiresAuth: true
    },
  },
  {
    path: '/tourism/new',
    component: () => import('@/views/Tourism/New.vue'),
    name: 'tourism-new',
    meta: {
      navName: 'tourism',
      sideNav: true,
      requiresAuth: true
    }
  },
  {
    path: '/tourism/:id',
    component: () => import('@/views/Tourism/Edit.vue'),
    name: 'tourism-edit',
    meta: {
      navName: 'tourism',
      sideNav: true,
      requiresAuth: true
    }
  }
]
